/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-block[_ngcontent-%COMP%]{right:2px;bottom:55px;height:0}.bulkassign-text[_ngcontent-%COMP%]{text-transform:uppercase;color:#0f7bb6}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/form-tickets.component.less.shim.ngstyle.js.pre-build-optimizer.js